import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  header: css`
    display: flex;
    align-items: center;
    padding: 0px 16px;
  `,
  container: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
  content: css`
    flex-grow: 1;
  `,
  title: css`
    width: 95%;
    text-align: center;
  `,
  section: css`
    padding: 0px 16px;
  `,
  tabHeaderSpacing: css`
    margin-top: 24px;
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
    padding-bottom: 47px;
  `,
  sectionSpacing: css`
    padding-top: 24px;
  `,
  sectionTitleContainer: css`
    padding-bottom: 12px;
  `,
  endMessage: css`
    display: flex;
    justify-content: center;
    margin-top: 100px;
    margin-bottom: 20px;
  `,
  seeMoreFlyersContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 0px 32px;
  `,
  seeMoreFlyersButton: css`
    text-transform: none !important;
  `,
  headerContainer: css`
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    padding-bottom: 12px;
  `,
  viewAllFlyersContainer: css`
    padding: 16px 0px 48px 0px;
    display: flex;
    justify-content: center;
  `,
  // buttonGrid: css`
  //   margin-left: auto;
  // `,
};

export default styles;
